import React, {useEffect, useRef, useState} from 'react';
import styles from './camera.module.scss'
import {useWindowDimensions} from "../../hooks";

declare var Cropper: any;
const Camera = (props: any) => {

    const context = useRef<any>();
    const player = useRef<any>();
    const canvas = useRef<any>();
    const localStream = useRef<any>();
    const [src, setSrc] = useState<string>('');
    const [cameraWidth, setCameraWidth] = useState<number>(0);
    const [cameraHeight, setCameraHeight] = useState<number>(0);
    const [canvasWidth, setCanvasWidth] = useState<number>(0);
    const [canvasHeight, setCanvasHeight] = useState<number>(0);
    const [deviceCameraWidth, setDeviceCameraWidth] = useState<number>(0);
    const [deviceCameraHeight, setDeviceCameraHeight] = useState<number>(0);
    const cropper = useRef<any>();
    const {width: windowWidth, height: windowHeight} = useWindowDimensions(false)
    useEffect(() => {

        getUserMedia();

        return () => {
            localStream?.current?.getTracks()?.forEach(track => track.stop())
        }

    }, [])
    useEffect(() => {
        if (windowWidth === deviceCameraWidth && windowHeight === deviceCameraHeight) {
            setCameraWidth(deviceCameraWidth);
            setCameraHeight(deviceCameraHeight);
        } else {
            const deviceCameraSizeRatio = deviceCameraWidth / deviceCameraHeight;
            let calculatedWidth = windowWidth;
            let calculatedHeight = calculatedWidth / deviceCameraSizeRatio;
            if (calculatedHeight > windowHeight) {
                calculatedHeight = windowHeight;
                calculatedWidth = calculatedHeight * deviceCameraSizeRatio;
            }
            setCameraWidth(calculatedWidth)
            setCameraHeight(calculatedHeight)
            const devicePixelRatio = window.devicePixelRatio || 0;
            setCanvasWidth(devicePixelRatio > 1 ? calculatedWidth * devicePixelRatio : calculatedWidth)
            setCanvasHeight(devicePixelRatio > 1 ? calculatedHeight * devicePixelRatio : calculatedHeight)

        }
    }, [windowWidth, windowHeight, deviceCameraWidth, deviceCameraHeight])
    const getUserMedia = () => {
        const constraints = {
            audio: false,
            video: {
                facingMode: 'environment'
            }
        };

        // Attach the video stream to the video element and autoplay.
        navigator.mediaDevices.getUserMedia(constraints)
            .then((stream) => {
                localStream.current = stream;

                const {width, height} = stream.getVideoTracks()[0].getSettings();
                setDeviceCameraWidth(width || 0);
                setDeviceCameraHeight(height || 0);
                if (player.current) {
                    player.current.srcObject = stream;
                }
            });
    }

    const onCapture = () => {
        context.current = (canvas.current).getContext('2d');
        context.current.drawImage(player.current, 0, 0, canvasWidth, canvasHeight);
        let image_data_url = canvas.current.toDataURL('image/jpeg', 1);
        setSrc(image_data_url)
    }

    useEffect(() => {
        if (src) {
            doCropper();
        }
    }, [src])


    const doCropper = () => {
        const image = document.getElementById('image');
        image?.setAttribute('src', src)
        cropper.current = new Cropper(image, {
            cropBoxResizable: true,
            // aspectRatio: deviceCameraWidth / deviceCameraHeight,
            initialAspectRatio: deviceCameraWidth / deviceCameraHeight,
        });
    }

    const getCroppedImage = () => {
        const canvas = cropper.current.getCroppedCanvas({
            width: cameraWidth,
            height: cameraHeight,
        });
        const source = canvas.toDataURL('image/jpeg', 1);
        props.onCapture(source);
    }

    return (
        <>
            <main className={styles.wrapper}>
                <div className={styles.camera} style={{
                    minWidth: `${cameraWidth}px`,
                    minHeight: `${cameraHeight}px`,
                    maxWidth: `${cameraWidth}px`,
                    maxHeight: `${cameraHeight}px`
                }}>

                    {!src ? (
                        <>
                            <video ref={player} id="player" autoPlay></video>
                            <button onClick={onCapture} type='button' className={`btn btn-md ${styles.capture}`}
                                    id="capture">GÖRÜNTÜ AL
                            </button>
                            <canvas ref={canvas} id="canvas" width={canvasWidth}
                                    height={canvasHeight}></canvas>
                        </>

                    ) : (
                        <>
                            <img id="image" style={{
                                minWidth: `${cameraWidth}px`,
                                minHeight: `${cameraHeight}px`,
                                maxWidth: `${cameraWidth}px`,
                                maxHeight: `${cameraHeight}px`
                            }}/>
                            <div className={styles.rotate}>
                                <button type="button" className="btn  pretty-btn"
                                        onClick={() => cropper.current.move(1, -1).rotate(-45)}>
                                <span className="docs-tooltip">
                                    <span className="fa fa-undo-alt"></span>
                                </span>
                                </button>
                                <button type="button" className="btn pretty-btn"
                                        onClick={() => cropper.current.move(1, -1).rotate(45)}>
                                <span className="docs-tooltip">
                                    <span className="fa fa-redo-alt"></span>
                                </span>
                                </button>
                            </div>
                            <button onClick={getCroppedImage} className={`btn btn-sm ${styles.capture}`}
                                    id="capture">GÖRÜNTÜ AL
                            </button>
                        </>
                    )}

                    {/*{src}*/}

                </div>
            </main>
        </>
    )

}

export default Camera;